import type { CachedCredentialDto } from '@terra/shared-contracts-authenticator';

export function hasReplayInjectableAuthMaterial({
  credential,
}: {
  credential: CachedCredentialDto;
}): boolean {
  return credential.headers.length > 0 || credential.cookies.length > 0;
}

export function hasReplayRunAllContext({
  credential,
  hasActivePreRequestScript,
}: {
  credential: CachedCredentialDto;
  hasActivePreRequestScript: boolean;
}): boolean {
  return (
    hasReplayInjectableAuthMaterial({ credential }) ||
    (hasActivePreRequestScript && credential.secrets.length > 0)
  );
}
